import omitBy from 'lodash/omitBy';

import {
  BIDING_STRATEGY,
  DAILY_BUDGET,
  LIFETIME_BUDGET,
  BID_AMOUNT,
  MIN_ROAS_BID,
} from './DynamicDataForms';
import {
  METRIC_AD_SET_BIDING_STRATEGY,
  METRIC_AD_SET_BID_AMOUNT,
  METRIC_AD_SET_DAILY_BUDGET,
  METRIC_AD_SET_LIFETIME_BUDGET,
  METRIC_AD_SET_STATUS,
  METRIC_AD_SET_MIN_ROAS_BID,
  METRIC_PARTNER_AD_BID_AMOUNT,
  METRIC_PARTNER_AD_STATUS,
  PLACEMENT_BID_AMOUNT,
  PLACEMENT_STATUS,
  METRIC_AD_CAMPAIGN_DAILY_BUDGET,
  METRIC_AD_CAMPAIGN_LIFETIME_BUDGET,
  METRIC_AD_CAMPAIGN_STATUS,
} from './constants';

const omitUndefined = (obj) => omitBy(obj, (v) => v === undefined);

export const mapDynamicDataToAdSet = ({
  [DAILY_BUDGET]: dailyBudget,
  [LIFETIME_BUDGET]: lifetimeBudget,
  [BID_AMOUNT]: bidAmount,
  [BIDING_STRATEGY]: bidingStrategy,
  [MIN_ROAS_BID]: minRoasBid,
  status,
}) =>
  omitUndefined({
    [METRIC_AD_SET_DAILY_BUDGET]: dailyBudget,
    [METRIC_AD_SET_LIFETIME_BUDGET]: lifetimeBudget,
    [METRIC_AD_SET_BIDING_STRATEGY]: bidingStrategy,
    [METRIC_AD_SET_BID_AMOUNT]: bidAmount || null,
    [METRIC_AD_SET_STATUS]: status,
    [METRIC_AD_SET_MIN_ROAS_BID]: minRoasBid || null,
  });

export const mapDynamicDataToPartnerAd = ({
  [BID_AMOUNT]: bidAmount,
  status,
}) =>
  omitUndefined({
    [METRIC_PARTNER_AD_BID_AMOUNT]: bidAmount,
    [METRIC_PARTNER_AD_STATUS]: status,
  });

export const mapDynamicDataToPartnerCampaign = ({
  [DAILY_BUDGET]: dailyBudget,
  [LIFETIME_BUDGET]: lifetimeBudget,
  status,
}) =>
  omitUndefined({
    [METRIC_AD_CAMPAIGN_DAILY_BUDGET]: dailyBudget,
    [METRIC_AD_CAMPAIGN_LIFETIME_BUDGET]: lifetimeBudget,
    [METRIC_AD_CAMPAIGN_STATUS]: status,
  });

export const mapDynamicDataToPlacement = ({
  [BID_AMOUNT]: bidAmount,
  status,
}) =>
  omitUndefined({
    [PLACEMENT_BID_AMOUNT]: bidAmount,
    [PLACEMENT_STATUS]: status,
  });
